import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import * as Sentry from '@sentry/angular-ivy'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { EnvironmentName } from './environments/environment.enum'
import packageJson from '../../../package.json'
import { RewriteFrames } from '@sentry/integrations'
import { appConfig } from './brands/_current/config/app-config'

if (appConfig.core.monitoring.enabled) {
  let env = 'dev'
  if (environment.name === EnvironmentName.Prod) {
    env = 'prod'
  } else if (environment.name === EnvironmentName.Cld) {
    env = 'cld'
  }
  Sentry.init({
    beforeSend: (event, hint) => {
      const exception =
        hint?.originalException instanceof Error ? hint?.originalException.stack : (hint?.originalException as string)
      const ignored = appConfig.core.monitoring.sentry.ignoreError.some((ignore) =>
        ignore instanceof RegExp ? ignore.test(exception) : exception === ignore,
      )

      // eslint-disable-next-line no-console,no-restricted-syntax
      console.info(`Error description: ${exception}`)
      // eslint-disable-next-line no-console,no-restricted-syntax
      console.info(`Error ignored: ${ignored}`)

      return ignored ? null : event
    },
    dsn: appConfig.core.monitoring.sentry.dsn,
    environment: env,
    tracesSampleRate: 0.05,
    maxBreadcrumbs: 50,
    release: packageJson.version,
    integrations: [new RewriteFrames()],
  })
}

// eslint-disable-next-line no-console,no-restricted-syntax
console.info(`v${packageJson.version}`, EnvironmentName[environment.name])

if (environment.name !== EnvironmentName.Dev) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))
